export default __webpack_public_path__ + "static/media/CarImages.PicantoGallery3.24a3ab96.jpg";